/**
 * Created by Andrey Popov on 03.11.2023
 */

const Crazy = function () {
    Platform.call(this, connector.CRAZY, {
        sdk: SdkManager.SDK_CRAZY
    });

    connector.social.needWindowForLogin = true;

    this.audioEnabled = true;
};

Crazy.prototype = Object.create(Platform.prototype);
Crazy.prototype.constructor = Crazy;

Crazy.prototype._connect = function (callback) {
    CrazyGames.SDK.game.loadingStart();

    this._subscribeAudio();

    if (CrazyGames.SDK.user.isUserAccountAvailable) {
        callback(connector.STATUS_CONNECTED);
    } else {
        callback(connector.STATUS_DISCONNECTED);
    }
};

Crazy.prototype.hasAudioControls = function () {
    return true;
};

Crazy.prototype.isAudioEnabled = function () {
    return this.audioEnabled;
};

Crazy.prototype._subscribeAudio = function () {
    if (this.audioListenerAdded) {
        return;
    }
    this.audioListenerAdded = true;

    const updateAudio = () => {
        const enabled = !CrazyGames.SDK.game.settings.muteAudio;
        if (this.audioEnabled !== enabled) {
            this.audioEnabled = enabled;
            this.bus.trigger("audioToggle", enabled);
        }
    };

    updateAudio();
    CrazyGames.SDK.game.addSettingsChangeListener(updateAudio);
};

Crazy.prototype.startGame = function (callback) {
    connector.platform.whenConnected(() => {
        CrazyGames.SDK.game.loadingStop();
    });

    callback();
};

Crazy.prototype.gameplayStart = function () {
    connector.platform.whenConnected(() => {
        CrazyGames.SDK.game.gameplayStart();
    });
};

Crazy.prototype.gameplayStop = function () {
    connector.platform.whenConnected(() => {
        CrazyGames.SDK.game.gameplayStop();
    });
};

Crazy.prototype.getLocalStoragePrefix = function () {
    return "_crazy";
};